import { TableHeader, type TableHeaderRow } from '@shared/table-generator';

const headers: TableHeaderRow[] = [
  {
    children: [
      {
        id: 'number',
        children: 'No.',
        align: 'center',
        sx: {
          width: '60px',
        },
      },
      {
        id: 'difficulty',
        children: 'ระดับความยาก',
        align: 'center',
        sx: { flex: 1 },
      },
      {
        id: 'calculation-type',
        children: 'ประเภทข้อสอบ',
        align: 'center',
        sx: { flex: 1, borderRight: 'none' },
      },
    ],
  },
];

export default function ItemSetQuestionPropertiesTableHeader() {
  return (
    <TableHeader
      columns={headers}
      slotProps={{
        tableHeaderRow: {
          sx: {
            height: '48px',
          },
        },
        tableHeader: {
          sx: (theme) => ({
            bgcolor: theme.palette.common.black,
            borderColor: theme.palette.grey[300],
            border: 'none',
          }),
        },
        tableHeaderCell: {
          sx: (theme) => ({
            ...theme.typography.body1Semibold,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            padding: theme.spacing(2, 3),
            borderRight: '1px solid',
            borderBottom: 'none',
            borderColor: theme.palette.grey[300],
          }),
        },
      }}
    />
  );
}
